<h2 mat-dialog-title>{{ data.modalTitle }}</h2>
<mat-dialog-content>
  <glxy-form-field>
    <mat-radio-group>
      <ng-container *ngFor="let association of associationFormArray.controls; let i = index">
        <glxy-label class="primary-text-color">{{ association?.get('name')?.value }}</glxy-label>
        <div class="radio-wrapper">
          <mat-radio-button
            class="primary-text-color"
            [checked]="association?.get('isPrimary')?.value"
            [value]="association?.get('id')?.value"
            (change)="setPrimaryAssociation(i)"
          >
            {{ data.primarySelect }}
            <extended>{{ data.description }}</extended>
          </mat-radio-button>
          <crm-edit-association-tags
            [tags]="association?.get('tags')?.value ?? []"
            [associationType]="data.associationType"
            (tagsChanged)="tagsChanged(i, $event)"
          ></crm-edit-association-tags>
        </div>
      </ng-container>
    </mat-radio-group>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">
    {{ 'ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save()">
    {{ 'ACTIONS.ADD' | translate }}
  </button>
</mat-dialog-actions>
